export function setOrAppendNoIndexMetaTag() {
  let metaElements = document.head.getElementsByTagName('meta')
  let noIndexMetaTag = null
  for (let i = 0; i < metaElements.length; i++) {
    if (metaElements[i].getAttribute('name') === 'robots') {
      noIndexMetaTag = metaElements[i]
    }
  }
  if (!noIndexMetaTag) {
    noIndexMetaTag = document.createElement('meta')
    noIndexMetaTag.setAttribute('name', 'robots')
    document.head.appendChild(noIndexMetaTag)
  }
  noIndexMetaTag.setAttribute('content', 'noindex')
}
